<script setup lang="ts">
import { useLDFlag } from 'launchdarkly-vue-client-sdk'

const { t } = useI18n()
const router = useRouter()

const {
  user,
  isRecycler,
  isAdmin,
  isProducer,
} = storeToRefs(useAuthStore())

// Feature flag
const welcomeScreenFeatureFlag = 'welcome-screen'
const welcomeScreenEnabled = useLDFlag(welcomeScreenFeatureFlag, false)

onMounted(async () => {
  if (!welcomeScreenEnabled.value)
    router.push('/collects')
})
</script>

<template>
  <div v-if="welcomeScreenEnabled" class="grow flex flex-col">
    <PageHeader
      :title="t('global.welome_screen', { name: user.user.firstName })"
      :subtitle="t('global.welcome_screen_description')"
      :show-back="false"
    />

    <div class="flex grow flex-col gap-4 md:gap-15">
      <!-- Driver must be the first one because a driver is also a recycler -->
      <ProducerHome v-if="isProducer && !isAdmin" />
      <RecyclerHome v-else-if="isRecycler && !isAdmin" />
      <AdminHome v-else-if="isAdmin" />
    </div>
  </div>
</template>

<route lang="yaml">
meta:
  layout: home
  requiresAuth: true
</route>
